var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-inline-flex tw-rounded-full tw-text-center tw-px-3 tw-py-1",class:_vm.themeClasses},[_c('span',{staticClass:"tw-font-semibold tw-flex tw-items-center"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }